import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Radio,
  Spin,
  Typography,
  Modal,
  Progress,
  Space,
} from "antd";
// import {
//   switchQuestion,
//   updateIsMarked,
//   fetchTestdata,
//   fetchTraineeTestQuestions,
//   fetchTraineeTestAnswerSheet,
// } from "../../../actions/traineeAction";
import {
  switchQuestion,
  updateTraineeTestAnswerSheet,
  setTraineeTestDetails,
  updateTraineeTestQuestions,
} from "../../../reducers/trainee";
import { Post, SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import { retriveToken } from "../../../services/AuthServices";
import TestBoardHeaderTest from "./TestBoardHeaderTest";
import diamond from "../../../assets/diamond.svg";
import InfoIcon from "../../../assets/quickResultInfo.svg";
import "./portal.css";
import "../alltest/allStudentTest.css";
import {
  fetchTestdata,
  fetchTraineeTestAnswerSheet,
  fetchTraineeTestQuestions,
} from "../../../features/trianeeAsync";

const SingleQuestion = ({ triggerSidebar, mode, title, loading }) => {
  const trainee = useSelector((state) => state.trainee);
  // console.log(trainee);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const activeQuestion = trainee?.questions?.[trainee?.activeQuestionIndex];
  //  console.log(activeQuestion);

  const activeAnswer = trainee?.answers?.[trainee?.activeQuestionIndex];
  // console.log(trainee);

  const initialState = {
    loading,
    AnswerSelected:
      activeAnswer.chosenOption.length === activeQuestion?.anscount,
    isModalOpen: false,
    isSubmitModalOpen: false,
    isQuickResultModalOpen: false,
    isCorrectionReview: false,
    isOpenLink: false,
    qickResult: {},
    badge: [],
    customAnswer: activeAnswer?.customAnswer || "",
    options: activeQuestion?.options,
    answers: activeAnswer?.chosenOption,
    ticked: 0,
  };

  const [state, setState] = useState(initialState);
  // console.log(state);

  useEffect(() => {
    if (!activeQuestion || !activeAnswer) return;

    let ticked = 0;
    const updatedOptions = activeQuestion.options?.map((d) => {
      if (activeAnswer.chosenOption.includes(d._id)) {
        ticked += 1;
        return { ...d, checked: true };
      }
      return { ...d, checked: false };
    });

    setState((prev) => ({
      ...prev,
      ticked,
      options: updatedOptions,
      answers: activeAnswer.chosenOption,
      customAnswer: activeAnswer.customAnswer || "",
      AnswerSelected:
        activeAnswer.chosenOption.length === activeQuestion.anscount,
    }));
  }, [activeQuestion, activeAnswer]);

  useEffect(() => {
    return () => {
      if (state.AnswerSelected) {
        saveToCloud();
      }
    };
  }, []);

  const saveToCloud = useCallback(() => {
    return Post({
      url: `${apis.UPDATE_ANSWERS}`,
      data: {
        testid: trainee.testid,
        userid: trainee.traineeid,
        qid: activeQuestion._id,
        newAnswer: state.answers,
        customAnswer: `${state.left || ""}${state.customAnswer || ""}${
          state.right || ""
        }`,
        isMcq: state.options.length > 0,
      },
    })
      .then((response) => {
        if (response.data.success) {
          const updatedAnswers = [...trainee.answers];
          updatedAnswers[trainee.activeQuestionIndex] = {
            ...updatedAnswers[trainee.activeQuestionIndex],
            chosenOption: state.customAnswer ? [] : state.answers,
            customAnswer: state.customAnswer || "",
            isAnswered: true,
          };
          // console.log("Updated", updatedAnswers);
          dispatch(updateTraineeTestAnswerSheet(updatedAnswers));
          dispatch(fetchTraineeTestQuestions(trainee.testid));
          dispatch(
            fetchTraineeTestAnswerSheet({
              testid: trainee.testid,
              userid: trainee.traineeid,
            })
          );
        } else {
          dispatch(setTraineeTestDetails(trainee.testid, trainee.traineeid));
        }
      })
      .catch((error) => {
        console.error("Error saving answer:", error);
      });
  }, [
    state.answers,
    state.customAnswer,
    state.options,
    state.left,
    state.right,
    trainee.testid,
    trainee.traineeid,
    trainee.activeQuestionIndex,
    activeQuestion._id,
    dispatch,
  ]);

  const handleOpenLink = () =>
    setState((prev) => ({ ...prev, isOpenLink: true }));
  const handleCancelLink = () =>
    setState((prev) => ({ ...prev, isOpenLink: false }));
  const handleOpen = () => setState((prev) => ({ ...prev, isModalOpen: true }));
  const handleCancel = () =>
    setState((prev) => ({ ...prev, isModalOpen: false }));
  const handleSubmitOpen = () => {
    setState((prev) => ({ ...prev, isSubmitModalOpen: true }));
    if (state.AnswerSelected) saveToCloud();
  };
  const handleSubmitCancel = () =>
    setState((prev) => ({ ...prev, isSubmitModalOpen: false }));

  const handleQuickResultOpen = () => {
    setState((prev) => ({ ...prev, isQuickResultModalOpen: true }));
    endTest();
  };
  const handleReveiwOpen = () => {
    setState((prev) => ({
      ...prev,
      isCorrectionReview: true,
      isQuickResultModalOpen: false,
    }));
  };
  const handleReveiwClose = () => {
    setState((prev) => ({
      ...prev,
      isCorrectionReview: false,
      isQuickResultModalOpen: true,
    }));
  };

  const handleCorrectionReview = (isCorrect) => {
    handleTestComplete();
    dispatch(switchQuestion(0));
    navigate(
      `/trainee/taketest?testid=${trainee.testid}&traineeid=${trainee.traineeid}&isCorrect=${isCorrect}`
    );
  };

  // const handleFullReview = () => {
  //   handleTestComplete();
  //   dispatch(switchQuestion(0));
  // };

  const previous = () => {
    if (state.AnswerSelected) {
      setState((prev) => ({ ...prev, loading: true }));
      saveToCloud().finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
        if (trainee.activeQuestionIndex > 0) {
          dispatch(switchQuestion(trainee.activeQuestionIndex - 1));
        }
      });
    } else {
      if (trainee.activeQuestionIndex > 0) {
        dispatch(switchQuestion(trainee.activeQuestionIndex - 1));
      }
    }
  };

  const next = () => {
    if (state.AnswerSelected) {
      setState((prev) => ({ ...prev, loading: false }));

      saveToCloud().finally(() => {
        setState((prev) => ({ ...prev, loading: true }));

        if (trainee.activeQuestionIndex < trainee.questions.length - 1) {
          dispatch(switchQuestion(trainee.activeQuestionIndex + 1));
        }
      });
    } else {
      if (trainee.activeQuestionIndex < trainee.questions.length - 1) {
        dispatch(switchQuestion(trainee.activeQuestionIndex + 1));
      }
    }
  };

  const mark = () => {
    const updatedAnswers = [...trainee.answers];
    updatedAnswers[trainee.activeQuestionIndex] = {
      ...updatedAnswers[trainee.activeQuestionIndex],
      isMarked: !updatedAnswers[trainee.activeQuestionIndex].isMarked,
    };
    dispatch(updateTraineeTestAnswerSheet(updatedAnswers));
  };

  const handleTestComplete = () => {
    dispatch(
      fetchTestdata({ testid: trainee.testid, traineeid: trainee.traineeid })
    );
  };

  const onAnswerChange = (index, checked, id) => {
    const ansCount = activeQuestion.anscount;
    if (checked) {
      const updatedOptions = state.options.map((opt, i) =>
        i === index ? { ...opt, checked: true } : { ...opt, checked: false }
      );
      setState((prev) => ({
        ...prev,
        AnswerSelected: true,
        ticked: 1,
        options: updatedOptions,
        answers: [id],
      }));
    } else {
      const updatedOptions = state.options.map((opt, i) =>
        i === index ? { ...opt, checked: false } : opt
      );
      setState((prev) => ({
        ...prev,
        AnswerSelected: false,
        ticked: 0,
        options: updatedOptions,
        answers: [],
      }));
    }
  };

  const endTest = () => {
    SecurePost({
      url: `${apis.END_TEST}`,
      data: {
        testid: trainee.testid,
        userid: trainee.traineeid,
      },
    })
      .then((response) => {
        if (response.data.success) {
          setState((prev) => ({ ...prev, qickResult: response.data.data }));
        }
      })
      .catch((error) => {
        console.error(error);
      });

    const token = retriveToken();
    if (token && token !== "undefined") {
      SecurePost({
        url: apis.GET_REWARD_BADGE,
        params: { Token: token },
      }).then((response) => {
        setState((prev) => ({ ...prev, badge: response.data }));
      });
    }
  };

  const opts = ["A", "B", "C", "D", "E"];
  const image = activeQuestion.quesimg?.split("www.leagueonline.sg:5000");
  // const path = apis.BASE_LOCAL_URL;
  const path = "https://www.leagueonline.sg:5000";
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const videoExtensions = ["mp4", "avi", "mov", "mkv"];
  const extension = activeQuestion.quesimg
    ? image && image[0] === "https://"
      ? image[1].split(".").pop().toLowerCase()
      : activeQuestion.quesimg.split(".").pop().toLowerCase()
    : "";

  return (
    <>
      <TestBoardHeaderTest
        testName={title}
        next={next}
        previous={previous}
        isSubmitted={
          trainee.activeQuestionIndex === trainee.questions.length - 1
        }
        handleSubmitOpen={handleSubmitOpen}
        trainee={trainee}
      />

      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        className="Question-single-container-new"
      >
        {state.loading === false ? (
          <Spin
            size="large"
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          />
        ) : (
          <div>
            <div style={{ zIndex: 999 }}>
              <Row>
                <Col className="leftColQuestionResult" span={24}>
                  {mode === "mobile" && (
                    <Button
                      onClick={triggerSidebar}
                      style={{ background: "#009999", color: "#fff" }}
                    >
                      Tool
                    </Button>
                  )}
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={24} style={{ fontSize: "1.2rem" }}>
                  <Typography className="marksText">
                    <span className="questionNoText">
                      Question {trainee.activeQuestionIndex + 1}
                    </span>
                    <span style={{ color: "red" }}>
                      {" "}
                      {activeQuestion.weightage} mark(s)
                    </span>
                  </Typography>
                  <div
                    className="questionBody"
                    dangerouslySetInnerHTML={{ __html: activeQuestion?.body }}
                  />
                </Col>
              </Row>

              <div className="Question-single-body-holder">
                {activeQuestion.quesimg && (
                  <div className="Single-question-body-image-container-new">
                    {imageExtensions.includes(extension) ? (
                      image && image[0] === "https://" ? (
                        <>
                          <img
                            style={{ cursor: "pointer" }}
                            src={path + image[1]}
                            className="image-tag"
                            onClick={handleOpen}
                          />
                          <Typography className="zoomInText">
                            Click on the image to zoom in.
                          </Typography>
                        </>
                      ) : (
                        <>
                          <img
                            style={{ cursor: "pointer" }}
                            src={path + "/" + activeQuestion.quesimg}
                            className="image-tag"
                            onClick={handleOpen}
                          />
                          <Typography>
                            Click on the image to zoom in.
                          </Typography>
                        </>
                      )
                    ) : videoExtensions.includes(extension) ? (
                      image && image[0] === "https://" ? (
                        <video className="image-tag" controls>
                          <source src={path + image[1]} type="video/mp4" />
                        </video>
                      ) : (
                        <video className="image-tag" controls>
                          <source
                            src={path + "/" + activeQuestion.quesimg}
                            type="video/mp4"
                          />
                        </video>
                      )
                    ) : null}
                  </div>
                )}
              </div>
            </div>

            <div className="Question-single-option-panel">
              <Row style={{ display: "flex", flexDirection: "column" }}>
                {state.options?.length > 0 &&
                  state.options.map((d, i) => (
                    <Col key={i} className="Single-option-new">
                      <Row
                        style={{
                          display: "flex",
                          gap: "5px",
                          cursor: "pointer", // Pointer cursor
                          borderRadius: "8px",
                          padding: "8px",
                          background: d.checked
                            ? "#D3D3D3"
                            : "transparent",
                        }}
                        onClick={() => onAnswerChange(i, true, d._id)} // Click anywhere to select
                      >
                        <Col>
                          <Typography className="questionBody">
                            ({opts[i]})
                          </Typography>
                        </Col>

                        <Col
                          style={{
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: 1,
                          }}
                        >
                          <h3 className="questionBody" style={{ margin: 0 }}>
                            {d.optbody}
                          </h3>

                          <div
                            className={
                              d.optimg
                                ? "option-image-in-exam-panel-holder"
                                : "option-image-in-exam-panel-holder-w0"
                            }
                          >
                            {d.optimg && (
                              <img
                                crossOrigin="anonymous"
                                alt="Unable to load"
                                className="option-image-in-exam-panel"
                                width="150px"
                                height="150px"
                                style={{ marginLeft: "12px" }}
                                src={d.optimg}
                              />
                            )}
                          </div>

                          <Radio
                            checked={d.checked}
                            size="large"
                            buttonStyle="solid"
                            className="radioQuestion"
                            onChange={(e) =>
                              onAnswerChange(i, e.target.checked, d._id)
                            }
                            style={{ pointerEvents: "none" }} // Prevent double click interference
                          />
                        </Col>
                      </Row>
                    </Col>
                  ))}
                {activeQuestion.quesimgUrl && (
                  <Typography className="openlink" onClick={handleOpenLink}>
                    open link
                  </Typography>
                )}
                {activeQuestion.isLong ? (
                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px 20px",
                    }}
                    span={24}
                  >
                    <textarea
                      value={state.customAnswer}
                      name="answer"
                      className="ansInput"
                      rows={5}
                      style={{ backgroundColor: "white", width: "inherit" }}
                      onChange={(e) =>
                        setState((prev) => ({
                          ...prev,
                          customAnswer: e.target.value,
                        }))
                      }
                      required
                    />
                  </Col>
                ) : activeQuestion.isShort ? (
                  <Col
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    span={23}
                  >
                    <Row
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        bottom: 0,
                        gap: 4,
                      }}
                    >
                      {activeQuestion.position === "left" && (
                        <Col>
                          <Typography
                            style={{
                              fontWeight: "600",
                              fontSize: "22px",
                              textAlign: "end",
                            }}
                          >
                            {activeQuestion.unit}
                          </Typography>
                        </Col>
                      )}
                      <Col className="ansInputp" span={18}>
                        <textarea
                          value={state.customAnswer}
                          name="answer"
                          rows={1}
                          className="ansInput"
                          style={{ backgroundColor: "white" }}
                          onChange={(e) =>
                            setState((prev) => ({
                              ...prev,
                              customAnswer: e.target.value,
                            }))
                          }
                          required
                        />
                      </Col>
                      {activeQuestion.position === "right" && (
                        <Col>
                          <Typography
                            style={{ fontWeight: "600", fontSize: "22px" }}
                          >
                            {activeQuestion.unit}
                          </Typography>
                        </Col>
                      )}
                    </Row>
                  </Col>
                ) : null}
              </Row>
            </div>
          </div>
        )}
      </div>

      <Modal
        open={state.isOpenLink}
        footer={null}
        closable={false}
        centered
        onCancel={handleCancelLink}
        width={650}
        className="modalLink"
        style={{ borderRadius: "25px", zIndex: 9999999999999, padding: 0 }}
      >
        <div
          style={{ maxHeight: "vh", overflowY: "auto" }}
          className="openLinkModalWrapper"
        >
          <img
            style={{ cursor: "pointer" }}
            src={activeQuestion.quesimgUrl}
            width="100%"
          />
        </div>
      </Modal>

      <Modal
        open={state.isModalOpen}
        footer={null}
        closable={false}
        centered
        onCancel={handleCancel}
        width={750}
        style={{
          borderRadius: "25px",
          zIndex: 99999999,
          height: "100%",
          padding: 0,
        }}
      >
        {activeQuestion.quesimg && imageExtensions.includes(extension) && (
          <img
            style={{ cursor: "pointer", width:"100%", maxHeight:"400px", objectFit:'contain' }}
            src={
              image && image[0] === "https://"
                ? path + image[1]
                : path + "/" + activeQuestion.quesimg
            }
          />
        )}
      </Modal>

      <Modal
        open={state.isSubmitModalOpen}
        footer={null}
        closable={false}
        centered
        onCancel={handleSubmitCancel}
        width={350}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        <p className="modalTitle">
          Are you sure you want to submit this assignment?
        </p>
        <div className="modalButtons">
          <Button className="modalButtonYes" onClick={handleQuickResultOpen}>
            Yes
          </Button>
          <Button className="modalButtonNo" onClick={handleSubmitCancel}>
            No
          </Button>
        </div>
      </Modal>

      <Modal
        open={state.isQuickResultModalOpen}
        footer={null}
        closable={false}
        centered
        width={550}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        {Object.keys(state.qickResult).length !== 0 ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Typography
              style={{ fontWeight: 600, fontSize: "18px" }}
              className="quickResultText"
            >
              {trainee.questions.find((item) => item.isLong)
                ? "Final Results Pending"
                : ""}
            </Typography>
            {trainee.questions.find((item) => item.isLong) ? (
              <Row>
                <Col span={24}>
                  <div className="quickResultModalParrent">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: "pointer",
                        justifyContent: "center",
                      }}
                    >
                      <Typography className="quickResultText">
                        Graded <br />
                        Component <br />
                        Marks
                      </Typography>
                      <div className="quickResultHoverInfoBox">
                        <img className="infoIcon" src={InfoIcon} alt="" />
                        <div className="quickResultInfo">
                          <Typography className="quickResultInfoText">
                            Due to the inclusion of open-ended questions in this
                            worksheet, this paper requires manual review...
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.studentScorePercentage || 0}
                        strokeColor={
                          state.qickResult.studentScorePercentage <
                            state.qickResult.allStudentsMarksPercent &&
                          state.qickResult.studentScorePercentage > 50
                            ? "#FAFF1C"
                            : state.qickResult.studentScorePercentage >=
                                state.qickResult.allStudentsMarksPercent &&
                              state.qickResult.studentScorePercentage > 50
                            ? "#67FF0B"
                            : state.qickResult.studentScorePercentage < 50
                            ? "red"
                            : "red"
                        }
                        size={10}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.studentScore}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {state.qickResult.studentScorePercentage}%
                      <br />
                      {state.qickResult.studentGrade}
                    </Typography>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={12}>
                  <div className="quickResultModalParrent">
                    <Typography className="quickResultText">
                      Your <br />
                      Marks
                    </Typography>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.studentScorePercentage || 0}
                        strokeColor={
                          state.qickResult.studentScorePercentage <
                            state.qickResult.allStudentsMarksPercent &&
                          state.qickResult.studentScorePercentage > 50
                            ? "#FAFF1C"
                            : state.qickResult.studentScorePercentage >=
                                state.qickResult.allStudentsMarksPercent &&
                              state.qickResult.studentScorePercentage > 50
                            ? "#67FF0B"
                            : state.qickResult.studentScorePercentage < 50
                            ? "red"
                            : "red"
                        }
                        size={10}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.studentScore}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {state.qickResult.studentScorePercentage}%
                      <br />
                      {state.qickResult.studentGrade}
                    </Typography>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="quickResultModalParrent">
                    <Typography className="quickResultText">
                      Average <br /> Marks
                    </Typography>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.allStudentsMarksPercent || 0}
                        strokeColor="#fff"
                        size={10}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.allStudentsMarksAverage}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {state.qickResult.allStudentsMarksPercent}%
                      <br />
                      {state.qickResult.totalGrade}
                    </Typography>
                  </div>
                </Col>
              </Row>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <Typography
                style={{ fontWeight: 400 }}
                className="quickResultText"
              >
                Points earned:
              </Typography>
              {state.qickResult.monthlyCapReached ? (
                <Typography
                  style={{ fontWeight: 400 }}
                  className="quickResultText"
                >
                  (Monthly Point Cap Reached)
                </Typography>
              ) : (
                <div>
                  <Typography
                    style={{ fontWeight: 400 }}
                    className="quickResultText"
                  >
                    + <img width="22px" src={diamond} alt="" />{" "}
                    {state.qickResult.earnPoint} points
                    <sub style={{ fontSize: "14px" }}>(completion)</sub>
                  </Typography>
                  <Typography
                    style={{ fontWeight: 400 }}
                    className="quickResultText"
                  >
                    + <img width="22px" src={diamond} alt="" />{" "}
                    {state.qickResult.performancePoint} Points{" "}
                    <sub style={{ fontSize: "14px" }}>(performance bonus)</sub>
                  </Typography>
                </div>
              )}
              <div>
                <Typography
                  style={{ fontWeight: 700, color: "#888888" }}
                  className="quickResultText"
                >
                  <img width="22px" src={diamond} alt="" />{" "}
                  {state.qickResult.totalPoints} points
                </Typography>
                <Typography
                  style={{
                    fontWeight: 400,
                    color: "#BABABA",
                    fontSize: "18px",
                  }}
                  className="quickResultText"
                >
                  Points Accumulated
                </Typography>
              </div>
            </div>

            <Row justify="center">
              <Col>
                <div className="modalButtons">
                  <Button className="modalButtonNo" onClick={handleReveiwOpen}>
                    Review Test
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      handleTestComplete();
                      dispatch(switchQuestion(0));
                      navigate("/user/livetest");
                    }}
                  >
                    Return to Take Test page
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      handleTestComplete();
                      dispatch(switchQuestion(0));
                      navigate("/user/testHistory");
                    }}
                  >
                    Return to Test History
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        )}
      </Modal>

      <Modal
        open={state.isCorrectionReview}
        onCancel={handleReveiwClose}
        footer={null}
        closable={false}
        centered
        width={400}
        style={{ borderRadius: 20, zIndex: 999999 }}
      >
        <Typography.Title
          level={4}
          className="modalTitle"
          style={{ textAlign: "center" }}
        >
          Which review option do you wish to choose?
        </Typography.Title>

        <Space
          direction="vertical"
          size="middle"
          style={{ width: "100%", marginTop: 24 }}
        >
          <Button
            block
            size="large"
            className="modalButtonNo"
            onClick={() => handleCorrectionReview(true)}
          >
            Full Review
          </Button>
          <Button
            block
            size="large"
            type="primary"
            className="modalButtonNo"
            onClick={() => handleCorrectionReview(false)}
          >
            Correction Review
          </Button>
        </Space>
      </Modal>
    </>
  );
};

export default SingleQuestion;
